module.exports = __webpack_public_path__ + "assets/src/style/img/svg/icons/category-learn-connect.svg?55159ce77066ad13c9292b613009613a";